import { atom } from "recoil";

export const defaultReactivateAccountFormState = {
    usrId : "",
    usrEmlAddr : "",
};
const reactivateAccountFormState = atom<{
    usrId: string;
    usrEmlAddr: string;
}>({
    key: "reactivateAccountFormState",
    default: defaultReactivateAccountFormState,
});

export default reactivateAccountFormState;
